import React from 'react';
import { useTranslation } from 'react-i18next';
import { Play, Gamepad2, Sparkles } from 'lucide-react';

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background effects */}
      <div className="absolute inset-0 grid-pattern" />
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-500/20 rounded-full blur-[128px]" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/20 rounded-full blur-[128px]" />
      
      {/* Floating elements */}
      <div className="absolute top-1/3 left-10 animate-float">
        <div className="w-16 h-16 rounded-xl gaming-gradient opacity-20 rotate-12" />
      </div>
      <div className="absolute top-1/2 right-20 animate-float" style={{ animationDelay: '1s' }}>
        <div className="w-12 h-12 rounded-lg gaming-gradient opacity-30 -rotate-12" />
      </div>
      <div className="absolute bottom-1/3 left-1/4 animate-float" style={{ animationDelay: '2s' }}>
        <div className="w-8 h-8 rounded-md gaming-gradient opacity-25 rotate-45" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-8">
          <Sparkles className="w-4 h-4 text-red-500" />
          <span className="text-sm text-white/70">Premium Mobile Gaming Platform</span>
        </div>

        {/* Main heading */}
        <h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-black mb-6">
          <span className="gaming-gradient-text">{t('hero.title')}</span>
        </h1>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-white/70 max-w-3xl mx-auto mb-10 leading-relaxed">
          {t('hero.subtitle')}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a 
            href="/s" 
            className="glow-button px-8 py-4 rounded-xl font-semibold text-white flex items-center gap-2 text-lg animate-pulse-glow"
          >
            <Play className="w-5 h-5" fill="currentColor" />
            {t('hero.cta1')}
          </a>
          <a 
            href="/s" 
            className="secondary-button px-8 py-4 rounded-xl font-semibold text-white flex items-center gap-2 text-lg"
          >
            <Gamepad2 className="w-5 h-5" />
            {t('hero.cta2')}
          </a>
        </div>

        {/* Decorative gaming icons */}
        <div className="mt-16 flex justify-center gap-8 opacity-30">
          <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-red-500/20 to-transparent border border-red-500/20 flex items-center justify-center">
            <Gamepad2 className="w-10 h-10 text-red-500" />
          </div>
          <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-purple-500/20 to-transparent border border-purple-500/20 flex items-center justify-center hidden sm:flex">
            <svg className="w-10 h-10 text-purple-500" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
            </svg>
          </div>
          <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-blue-500/20 to-transparent border border-blue-500/20 flex items-center justify-center hidden md:flex">
            <svg className="w-10 h-10 text-blue-500" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6 4L6 20L18 12L6 4Z" />
            </svg>
          </div>
        </div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#05050a] to-transparent" />
    </section>
  );
};

export default Hero;
